import { useRef, useState } from "react";
import { 
  Autocomplete,
  Button,
  Card, 
  CardActions, 
  CardContent, 
  CardHeader, 
  DataGrid,
  FullscreenDialog,
  Grid,
  TextField,
  Tooltip
} from "../../../../components";
import { PessoaService } from "../../../../services";
import { responseErros, timeoutBuscaAutocomplete } from "../../../../utils";
import AddPessoas from "../../../pessoas/addPessoa/addPessoa.view";

const AutorizadoresDatagrid = ({
  empresa,
  setEmpresa,
  setOpenDialogAutorizadores,
  rowCount, 
  setRowCount
}) => {

  const inputRef = useRef();
  const [optionsAutocomplete, setOptionsAutocomplete] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const [isCadastroPessoaDialogOpen, setIsCadastroPessoaDialogOpen] =
      useState(false);
  const pessoaService = new PessoaService();

  const colunas = [
    {
      field: "naturezaSocial",
      headerName: "Tipo",
      flex: 200,
      valueFormatter: (params) => 
          params.value.charAt(0).toUpperCase() + 
          params.value.slice(1)
    },
    {
      field: "cnpjCpf",
      headerName: "CPF/CNPJ",
      flex: 300,
      filtrar: true,
    },
    {
      field: "nomeRazaoSocial",
      headerName: "Nome/Razão Social",
      flex: 500,
      filtrar: true,
    },
  ];

  const buscaPessoas = async function (filter) {
    const result = await pessoaService.getAll(filter);
    if (!result.isAxiosError) {
      const autorizadoresId = empresa.autorizadores.map(({id}) => id);
      const filterResult = result.data.rows.filter(({id}) => !autorizadoresId.includes(id));
      setOptionsAutocomplete(filterResult);
    } else {
      responseErros(result);
    }
  };

  const onInputChangeAutocomplete = (event) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const eventValue = event.target?.value;
      if (eventValue?.length >= 2) {
        const filtros = {
          nomeRazaoSocial: eventValue,
        };
        setLoadingAutoComplete(true);
        timeoutBuscaAutocomplete(buscaPessoas(filtros));
      }
    }
  };

  const onChangeAutocomplete = (value) => {
    const existeAutorizador = empresa.autorizadores.find(({id}) => id === value.id);
    if (!existeAutorizador) {
      setRowCount(empresa.autorizadores.length + 1);
      setEmpresa((prevState) => {
        const autorizadores = [ ...prevState.autorizadores, value];
        return ({ ...prevState,  autorizadores})
      });
      setOptionsAutocomplete([]);
      if(inputRef.current) {
        inputRef.current?.blur(); 
        inputRef.current?.focus();
      }
    }
    setLoadingAutoComplete(false);
  }

  const onClickDelete = (id) => {
    const filter = empresa.autorizadores.filter((item) => item.id !== id);
    setEmpresa((prevState) => ({ ...prevState,  autorizadores: filter }));
    setRowCount(empresa.autorizadores.length - 1);
  }

  const handleCloseCadastroCliente = () => {
    setIsCadastroPessoaDialogOpen(false);
  };

  const onRegisterCliente = (data) => {
    const newValue = [ ...empresa.autorizadores, data ];
    setEmpresa((prevState) => ({ ...prevState, autorizadores: newValue }));
  }

  return (
    <Card className="p-3">
      <CardHeader title="Autorizadores" />
      <CardContent className="p-3">
        <Grid container spacing={2} alignItems={"center"} sx={{ marginBottom: "1rem" }}>
          <Grid item xs={11}>
            <Autocomplete
              id="pessoa"
              name="pessoa"
              options={optionsAutocomplete}
              autoHighlight
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              filterSelectedOptions
              getOptionLabel={(option) =>
                option ? option.nomeRazaoSocial : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  id="nomeRazaoSocial"
                  variant="outlined"
                  label="Pesquise por Nome/Razão Social"
                  onKeyDown={(e) => onInputChangeAutocomplete(e)}
                  inputRef={inputRef}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, newValue) =>
                onChangeAutocomplete(newValue)
              }
            />
          </Grid>
          <Grid item xs={1} className="d-flex justify-content-center">
            <Tooltip title="Cadastrar Pessoa" arrow placement="bottom">
              <Button
                id="buttonAdicionarCliente"
                variant="contained"
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => setIsCadastroPessoaDialogOpen(true)}
              >
                <i
                  className="ph-bold ph-plus"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
        <DataGrid
          rows={empresa?.autorizadores}
          columns={colunas}
          paginationMode={"server"}
          rowCount={rowCount}
          noFilter
          hideFiltroAvancado
          deleteShow
          onClickDelete={onClickDelete}
        />
      </CardContent>
      <CardActions>
        <Button
          color="inherit"
          variant="contained"
          onClick={() => setOpenDialogAutorizadores(false)}
        >
          Fechar
        </Button>
      </CardActions>
      <FullscreenDialog
        open={isCadastroPessoaDialogOpen}
        handleClose={handleCloseCadastroCliente}
        content={
          <AddPessoas
            match={{ params: { id: null } }}
            isFullscreenDialog
            onChangeCliente={onRegisterCliente}
            handleCloseFullscreenDialog={handleCloseCadastroCliente}
          />
        }
      />
    </Card>
  )
};  

export default AutorizadoresDatagrid;